module.exports = __webpack_public_path__ + "img/img5.e94847f3.svg";